import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const container = document.getElementById("root");
const app = (
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

const path = window.location.pathname.replace(/\/+$/, "") || "/";
const prerenderedFor = container.dataset.prerendered;
if (prerenderedFor === path) {
  ReactDOM.hydrateRoot(container, app);
} else {
  delete container.dataset.prerendered;
  ReactDOM.createRoot(container).render(app);
}

if (process.env.NODE_ENV === "production" && "serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    setTimeout(() => navigator.serviceWorker.register("/sw.js").catch(() => {}), 4000);
  });
}
